import { createBrowserRouter } from "react-router-dom";
import Control from "./Pages/Control/Control";
import { CompetitionOverview } from "./Pages/Control/Competition/Overview";
import { PlayerOverview } from "./Pages/Control/Player/Overview";
import { TeamOverview } from "./Pages/Control/Team/Overview";
import { CompetitionDetail } from "./Pages/Control/Competition/Detail";
import { GameNew } from "./Pages/Control/Game/New";
import { TeamNew } from "./Pages/Control/Team/New";
import { PlayerNew } from "./Pages/Control/Player/New";
import { CompetitionNew } from "./Pages/Control/Competition/New";
import { Groups } from "./Pages/Control/Competition/Groups";
import { SetMatchdayTeams } from "./Pages/Control/Competition/SetMatchdayTeams";
import { ChangeDateTime } from "./Pages/Control/Game/ChangeDateTime";
import { ChangeTeam } from "./Pages/Control/Player/ChangeTeam";
import { PlayerEdit } from "./Pages/Control/Player/Edit";
import { Regie } from "./Pages/Control/Regie/Regie";
import { Ledwall } from "./Pages/Control/Ledwall/Ledwall";
import { Streamelements } from "./Pages/Stremelements/Streamelements";
import { Score } from "./Pages/Stremelements/Elements/Score";
import { Shootout } from "./Pages/Stremelements/Elements/Shootout";
import { Commentator } from "./Pages/Control/Commentator/Commentator";
import { NextMatch } from "./Pages/Stremelements/Elements/NextMatch";
import { Leaderboard as StreamElementLeaderboard } from "./Pages/Stremelements/Elements/Leaderboard";
import { Topscorer as StreamElementTopscorer } from "./Pages/Stremelements/Elements/Topscorer";
import { App } from "./Pages/App/App";
import { GamesPage } from "./Pages/App/Components/Pages/Games";
import { TeamsPage } from "./Pages/App/Components/Pages/Teams";
import { TopscorerPage } from "./Pages/App/Components/Pages/Topscorer";
import { LeaderboardPage } from "./Pages/App/Components/Pages/Leaderboard";
import { TeamPage } from "./Pages/App/Components/Pages/Team";
import { TopscorerFullscreen } from "./Pages/Stremelements/Elements/TopscorerFullscreen";
import { LeaderboardFullscreen } from "./Pages/Stremelements/Elements/LeaderboardFullscreen";
import { SquadFullscreen } from "./Pages/Stremelements/Elements/SquadFullscreen";
import { Countdown } from "./Pages/Stremelements/Elements/Countdown";
import { GoalScorer } from "./Pages/Stremelements/Elements/GoalScorer";
import { ChangeDuration } from "./Pages/Control/Game/ChangeDuration.tsx";
import { ChangeShootOutShotsNumber } from "./Pages/Control/Game/ChangeShootOutShotsNumber.tsx";
import { CompetitionContext } from "./CompetitionContext.tsx";
import { Command } from "./Pages/Control/Command/Command.tsx";
import { Timekeeper } from "./Pages/Control/Game/Timekeeper.tsx";
import { RouteWrapper } from "./Pages/Control/Game/RouteWrapper.tsx";
import { getPresentationParamsForOrigin } from "./getPresentationParamsForOrigin.ts";
import { StreamElementLinksOverview } from "./Pages/Control/StreamelementLinks/Overview.tsx";
import { AdOverview } from "./Pages/Control/Ads/AdOverview.tsx";
import { CompetitionOverviewDisplay } from "./Pages/Stremelements/Elements/CompetitionOverview.tsx";
import { RouteErrorPage } from "./Components/RouteErrorPage";
import { Dashboard } from "./Pages/Control/Dashboard/Dashboard.tsx";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: (
      <CompetitionContext.Provider
        value={getPresentationParamsForOrigin().competitionId}
      >
        <App />
      </CompetitionContext.Provider>
    ),
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: "games",
        element: <GamesPage />,
      },
      {
        path: "teams",
        element: <TeamsPage />,
      },
      {
        path: "teams/:teamId",
        element: <TeamPage />,
      },
      {
        path: "leaderboard",
        element: <LeaderboardPage />,
      },
      {
        path: "leaderboard/:leaderboardPageKey",
        element: <LeaderboardPage />,
      },
      {
        path: "topscorer",
        element: <TopscorerPage />,
      },
    ],
  },
  {
    path: "streamelements",
    element: <Streamelements />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: "score",
        element: <Score />,
      },
      {
        path: "shootout",
        element: <Shootout />,
      },
      {
        path: "next-match",
        element: <NextMatch />,
      },
      {
        path: ":competitionId/:groupId/leaderboard",
        element: <StreamElementLeaderboard />,
      },
      {
        path: "topscorer",
        element: <StreamElementTopscorer />,
      },
      {
        path: "goal-scorer",
        element: <GoalScorer />,
      },
      {
        path: "topscorer-fullscreen",
        element: <TopscorerFullscreen />,
      },
      {
        path: ":competitionId/:groupId/leaderboard-fullscreen",
        element: <LeaderboardFullscreen />,
      },
      {
        path: "countdown",
        element: <Countdown />,
      },
      {
        path: "squad-fullscreen",
        element: <SquadFullscreen />,
      },
      {
        path: "competition",
        element: <CompetitionOverviewDisplay />,
      },
    ],
  },
  {
    path: "control",
    element: <Control />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "competitions",
        element: <CompetitionOverview />,
      },
      {
        path: "competitions/new",
        element: <CompetitionNew />,
      },
      {
        path: "competitions/:competitionId",
        element: <CompetitionDetail />,
      },
      {
        path: "competitions/:competitionId/games/new",
        element: <GameNew />,
      },
      {
        path: "competitions/:competitionId/games/:gameId",
        element: <RouteWrapper />,
      },
      {
        path: "competitions/:competitionId/games/:gameId/change-datetime",
        element: <ChangeDateTime />,
      },
      {
        path: "competitions/:competitionId/games/:gameId/change-duration",
        element: <ChangeDuration />,
      },
      {
        path: "competitions/:competitionId/games/:gameId/change-shoot-out-shots-number",
        element: <ChangeShootOutShotsNumber />,
      },
      {
        path: "competitions/:competitionId/groups",
        element: <Groups />,
      },
      {
        path: "competitions/:competitionId/matchdays/:matchdayId/teams",
        element: <SetMatchdayTeams />,
      },
      {
        path: "timekeeper",
        element: <Timekeeper />,
      },
      {
        path: "players",
        element: <PlayerOverview />,
      },
      {
        path: "players/new",
        element: <PlayerNew />,
      },
      {
        path: "players/:playerId/change-team",
        element: <ChangeTeam />,
      },
      {
        path: "players/:playerId/edit",
        element: <PlayerEdit />,
      },
      {
        path: "teams",
        element: <TeamOverview />,
      },
      {
        path: "teams/new",
        element: <TeamNew />,
      },
      {
        path: "regie",
        element: <Regie />,
      },
      {
        path: "ledwall",
        element: <Ledwall />,
      },
      {
        path: "commentator",
        element: <Commentator />,
      },
      {
        path: "command",
        element: <Command />,
      },
      {
        path: "streamelements",
        element: <StreamElementLinksOverview />,
      },
      {
        path: "ads",
        element: <AdOverview />,
      },
    ],
  },
]);
